export default __webpack_public_path__ + "static/media/H4011.4.03726f6f.mp3";